import { Box, ColorOptions, Icon, ModBox, Text } from '@jfs/ui-new'
import { FC } from 'react'
interface Prop {
  onProceed: () => void
  onBack: () => void
  currentStep: number
  title?: string
  isLoading: boolean
}

interface StepsItemProps {
  title: string
  index: number
  stepState: keyof typeof StepState
  steps: any[]
  onStepPressed?: (step: number) => null
  totalFilledStep?: any
  isStepDataValid?: boolean
  isNavigationAllowed?: boolean
  type?: 'DEFAULT' | 'READ_ONLY'
}

const StepState = {
  ACTIVE_SELECTED: 'active',
  ACTIVE_DORMANT: 'active',
  DISABLE: 'disable',
  COMPLETED_SELECTED: 'completed',
  COMPLETED_DORMANT: 'completed',
  FAILED: 'failed',
}

const StepsItem = ({
  title,
  stepState,
  index,
  steps,
  onStepPressed,
  totalFilledStep,
  isStepDataValid,
  isNavigationAllowed,
  type,
}: StepsItemProps) => {
  const handleStepPressed = () => {
    onStepPressed(index + 1)
  }
  return (
    <Box
      flexDirection="row"
      alignItems="center"
      bg={stepState.includes('SELECTED') ? ('#0070B614' as ColorOptions) : 'TRANSPARENT'}
      borderRightWidth={stepState.includes('SELECTED') ? 2 : 0}
      borderColor={'BLUE_SHADE_PRIMARY'}
      onPress={
        (isNavigationAllowed && (stepState.includes('COMPLETED') || stepState.includes('ACTIVE'))) ||
        type === 'READ_ONLY'
          ? handleStepPressed
          : handleStepPressed
      }
      underlayColor={'#0070B614' as ColorOptions}>
      <Box flexDirection={'column'} align={'center'} ph={16} h={48}>
        <ModBox align={'center'} show={type === 'DEFAULT'}>
          <Box w={'1'} h={16} bg={'BRAND_PRIMARY_GREEN'} opacity={0.2} />
          <Box
            w={16}
            h={16}
            borderColor={
              stepState === 'FAILED' && steps.length - 1 === index ? 'BRAND_PRIMARY_RED' : 'BLUE_SHADE_PRIMARY'
            }
            borderRadius={8}
            borderWidth={stepState.includes('COMPLETED') ? 0 : 1}
            opacity={
              stepState.includes('ACTIVE') || stepState.includes('COMPLETED') ? 1 : stepState === 'FAILED' ? 1 : 0.2
            }
            backgroundColor={stepState === 'FAILED' && steps.length - 1 === index ? 'BRAND_PRIMARY_RED' : undefined}
            justify={'center'}
            align={'center'}>
            {stepState.includes('COMPLETED') && (
              <Icon id={'SUCCESSFUL_FILLED'} size={16} color={'BRAND_PRIMARY_GREEN'} />
            )}
            {stepState === 'FAILED' && steps.length - 1 === index && <Icon id={'CLOSE'} size={10} color={'WHITE'} />}
          </Box>
          <ModBox show={index < steps.length - 1} w={'1'} h={16} bg={'BRAND_PRIMARY_GREEN'} opacity={0.2} />
        </ModBox>
      </Box>
      <Text
        title={title}
        color={stepState.includes('ACTIVE') || stepState.includes('COMPLETED') ? 'BLUE_SHADE_PRIMARY' : 'PRIMARY_GREY'}
        fontFamily={'jiotype-medium'}
        fontSize={12}
      />
    </Box>
  )
}

interface NewVerticalStepIndicatorProps {
  currentStep: number
  steps: string[]
  onStepPressed: any
  totalFilledStep: number
  type?: 'DEFAULT' | 'READ_ONLY'
  formValidationStatus: boolean[]
}

const NewVerticalStepIndicator: FC<any> = ({
  currentStep,
  steps = [],
  onStepPressed,
  totalFilledStep,
  formValidationStatus,
  type = 'DEFAULT',
}: NewVerticalStepIndicatorProps) => {
  const isNavigationAllowed = formValidationStatus[currentStep - 1] || totalFilledStep === currentStep
  return (
    <Box
      bg={'#0070B60A' as ColorOptions}
      f={1}
      w={220}
      borderRightWidth={1}
      borderRightColor={'#0000001F' as ColorOptions}
      overflow={'auto'}>
      {steps.map((item: any, index: number) => {
        return (
          <StepsItem
            isStepDataValid={formValidationStatus[index]}
            stepState={
              currentStep === index + 1
                ? formValidationStatus[index]
                  ? 'COMPLETED_SELECTED'
                  : 'ACTIVE_SELECTED'
                : currentStep > index + 1 || index < totalFilledStep
                ? formValidationStatus[index]
                  ? 'COMPLETED_DORMANT'
                  : 'ACTIVE_DORMANT'
                : 'DISABLE'
            }
            title={item}
            index={index}
            steps={steps}
            onStepPressed={onStepPressed}
            totalFilledStep={totalFilledStep}
            key={index}
            isNavigationAllowed={isNavigationAllowed}
            type={type}
          />
        )
      })}
    </Box>
  )
}

export { NewVerticalStepIndicator }
